export class SoackStyleInfo {
    soakstyleId: number;
    isActive?: boolean;
    versionFlag?: number;
    constructor(soakstyleId: number, isActive?: boolean, versionFlag?: number) {
        this.soakstyleId = soakstyleId;
        this.isActive = isActive
        this.versionFlag = versionFlag
    }
}